export const men = {
    all: {
        en: "All Mens Products",
        cn: "所有男子產品",
        jpn: "すべてのメンズ製品",
    },
};

export const women = {
    all: {
        en: "All Womens Products",
        cn: "所有女子產品",
        jpn: "すべての女性用製品",
    },
};

export const kids = {
    all: {
        en: "All Kids Products",
        cn: "所有兒童産品",
        jpn: "すべての子供向け製品",
    },
};

export const sale = {
    all: {
        en: "All Discounted Products",
        cn: "所有折扣產品",
        jpn: "すべての割引商品",
    },
};
